<app-funnel-shell>
  <div class="funnel-card">
    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.quiz.loading' | translate }}</p>
    }

    @if (question(); as q) {
      <div class="funnel-eyebrow">
        <img src="/assets/funnel/quiz.svg" alt="" />
        {{ 'funnel.quiz.progress' | translate: { current: q.progress.current, total: q.progress.total } }}
      </div>

      <h2 class="funnel-quiz__question">{{ q.i18n_key + '.question' | translate }}</h2>

      <p class="funnel-quiz__subtitle">{{ 'funnel.quiz.subtitle' | translate }}</p>

      <div class="funnel-quiz__options">
        @for (opt of q.options; track opt.value) {
          <button
            type="button"
            class="funnel-quiz__option"
            [disabled]="busy()"
            (click)="selectAnswer(opt.value)"
          >
            {{ opt.i18n_key | translate }}
          </button>
        }
      </div>

      @if (q.progress.current > 1) {
        <button
          type="button"
          class="funnel-quiz__back"
          [disabled]="busy()"
          (click)="goBack()"
        >
          &larr; {{ 'funnel.quiz.back' | translate }}
        </button>
      }

      <p class="funnel-quiz__hint">{{ 'funnel.quiz.resume_hint' | translate }}</p>
    }

    @if (error()) {
      <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
    }
  </div>
</app-funnel-shell>
